import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import { Image } from '@src/components/Image';
import { STATIC_MEDIA_DOMAIN } from '@src/constants';
import CloseSvg from '@src/svgs/fr-close.svg';
import { InfoModalProps } from './props';
import './styles.scss';

export const InfoModal: FC<InfoModalProps> = ({ onClose }) => {
  return (
    <div className="featured-applicants-info-modal">
      <div className="featured-applicants-info-modal__info-section">
        <h1>How does Passive Search work?</h1>
        <p>
          <br />
          <br />
          <ol type="1">
            <li>
              Talents make their profiles visible, providing detailed information about their experience and
              preferences.
            </li>
            <li>We carefully review and verify each talent before making them available to employers.</li>
            <li>
              Companies can browse, search, and view a daily batch of fresh talents who are actively broadcasting
              themselves, then respond to those they deem suitable for interviews.
            </li>
          </ol>
        </p>
      </div>
      <div className="featured-applicants-info-modal__image-section">
        <Image
          className="featured-applicants-info-modal__image"
          src={`${STATIC_MEDIA_DOMAIN}/images/explainer-open-pplicants.png`}
        />
        <Svg className="featured-applicants-info-modal__close-icon" onClick={onClose} src={CloseSvg} />
      </div>
    </div>
  );
};
